import React from "react";
import SeparateStatusTrend from "./SeparateStatusTrend";
import CombinedStatusTrend from "./CombinedStatusTrend";

const StatusTrendFactory = ({ approach = "SEPARATED", status, trend,
    showStatus = true, showTrend = true,
    className = null, locale = null }) => {

    switch (approach) {
        case 'SEPARATED':
            return (
                <SeparateStatusTrend status={status} trend={trend} className={className} showStatus={showStatus} showTrend={showTrend} />
            );
        case 'COMBINED':
            return (
                showStatus && showTrend ?
                <CombinedStatusTrend status={status} trend={trend} className={className} showStatus={showStatus} showTrend={showTrend} locale={locale} /> :
                <SeparateStatusTrend status={status} trend={trend} className={className} showStatus={showStatus} showTrend={showTrend} locale={locale} />
            );
        default:
            return (
                null
            );
    }

}

export default StatusTrendFactory;